import PropTypes from "prop-types";

const transGuideImageSmall = window.ASSETS?.busRaceGif || "/assets/images/bus-race.gif";
const transGuideImageSmallBW = window.ASSETS?.busRaceBWGif || "/assets/images/bus-race-bw.gif";

const SearchWelcomeComponent = ({ text, negative }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={negative ? transGuideImageSmallBW : transGuideImageSmall}
        alt="Bus race"
        className="w-full max-w-500px sm:w-[500px] my-12"
      />
      <span> {text} </span>
    </div>
  );
};

SearchWelcomeComponent.propTypes = {
  text: PropTypes.string,
  negative: PropTypes.bool,
};

export default SearchWelcomeComponent;
